// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkDocument: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 16" width={width} height={height}>
            <path
                fill="currentColor"
                d="M11 14V6H7.5A1.5 1.5 0 0 1 6 4.5V1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1m-.016-9a.5.5 0 0 0-.13-.231L7.23 1.147A.5.5 0 0 0 7 1.016V4.5c0 .275.225.5.5.5zM0 2C0 .897.897 0 2 0h4.878a1.5 1.5 0 0 1 1.06.44l3.621 3.62A1.5 1.5 0 0 1 12 5.118V14c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2z"
            />
        </svg>
    );
};

export default React.memo(LinkDocument);
